
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class RepairItemsGrid extends Serenity.EntityGrid<RepairItemsRow, any> {
        protected getColumnsKey() { return 'Repair.RepairItems'; }
        protected getDialogType() { return RepairItemsDialog; }
        protected getIdProperty() { return RepairItemsRow.idProperty; }
        protected getInsertPermission() { return RepairItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return RepairItemsRow.localTextPrefix; }
        protected getService() { return RepairItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
            this.slickGrid.setOptions({ rowHeight: 30 });
       
        }        
        
    }
}